import { api } from '../api';

const unwrap = (r) => r?.data ?? r;

export default {
  snapshot: (params) => api.get('/v1/dashboard/snapshot', { params }).then(r => unwrap(r.data)),
  activity: (params) => api.get('/v1/dashboard/activity', { params }).then(r => unwrap(r.data)),
  series:   (params) => api.get('/v1/dashboard/series',   { params }).then(r => unwrap(r.data)),
  voiceKpis:(params) => api.get('/v1/voice-loop/kpis',    { params }).then(r => unwrap(r.data)),

  /**
   * Stock-only report for the Inventory Controller dashboard view.
   * Returns: totalInStock, byAge{0_30,31_60,61_90,OVER_90}, byCondition,
   *          topByMake[], agedExposureCount, daysSupply, benchmark.
   */
  inventorySnapshot: () =>
    api.get('/v1/reports/inventory/snapshot').then(r => unwrap(r.data)),

  /**
   * Role-shaped dashboard payload.
   *
   * params { role, days, locationIds?, consultantId? }
   *
   * Returns `today` (always org-local today, independent of `days`), `window`
   * (governed by `days`), `exceptions`, and — depending on role — `team`,
   * `locations`, `aiVsHuman` and `mine`.
   *
   * `today` is deliberately separate from `window`: the operational counts a
   * dealer opens the page for must not move when the period toggle does.
   *
   * Scoping is server-side. The old dashboard derived its funnel, hot leads and
   * deal values client-side from the dealership-wide CRM context, which a
   * consultant view cannot safely filter in the browser.
   */
  roleSnapshot: (params) => api.get('/v1/dashboard/role-snapshot', { params }).then(r => unwrap(r.data)),
};
